import { render, staticRenderFns } from "./Desktop.vue?vue&type=template&id=28ff3d5f"
import script from "./Desktop.vue?vue&type=script&lang=js"
export * from "./Desktop.vue?vue&type=script&lang=js"
import style0 from "./Desktop.vue?vue&type=style&index=0&id=28ff3d5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports